<template>
  <div class="container-spinner text-center">
    <div class="spinner-border" :style="style" role="status">
      <span class="sr-only"></span>
    </div>
  </div>
</template>
<script>
export default {
  name: 'SpinnerLoading',
  props: {
    size: {
      type: Number,
      required: false,
    }
  },
  computed: {
    style() {
      if (!this.size) return;
      return {
        width: this.size + 'px',
        height: this.size + 'px'
      }
    }
  }
}
</script>
